import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (formData.message.length > 500) {
      alert('Message must be 500 characters or less');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('subject', formData.subject);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d4oppt7iu80n4l8qnjpg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-32 bg-[#FAF7F2]">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="grid grid-cols-5 gap-16">
          <div className="col-span-2">
            <h2 className="text-[#2C1810] text-[48px] font-bold mb-16">
              GET IN TOUCH
            </h2>

            <div className="space-y-12">
              <div className="flex items-start gap-5">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-[32px] text-[#00D9FF]"></i>
                </div>
                <div>
                  <div className="text-gray-500 text-sm uppercase tracking-[2px] mb-2">
                    Email
                  </div>
                  <a
                    href="mailto:info@brimaservicosdecobrancaltda.com"
                    className="text-[#2C1810] text-lg hover:text-[#00D9FF] transition-colors cursor-pointer"
                  >
                    info@brimaservicosdecobrancaltda.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-5">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-[32px] text-[#00D9FF]"></i>
                </div>
                <div>
                  <div className="text-gray-500 text-sm uppercase tracking-[2px] mb-2">
                    Phone
                  </div>
                  <a
                    href="tel:+15397669257"
                    className="text-[#2C1810] text-lg hover:text-[#00D9FF] transition-colors cursor-pointer"
                  >
                    +1 5397669257
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-5">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-[32px] text-[#00D9FF]"></i>
                </div>
                <div>
                  <div className="text-gray-500 text-sm uppercase tracking-[2px] mb-2">
                    Address
                  </div>
                  <div className="text-[#2C1810] text-lg leading-[1.6]">
                    Av. GENERALISSIMO DEODORO 1664<br />
                    8 ANDAR SALA 801<br />
                    BELEM, Brazil 66040-140
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-3">
            <div className="bg-white rounded-3xl p-10 shadow-lg">
              <h3 className="text-[#0D1B2A] text-3xl font-bold mb-8">
                Send us a message
              </h3>

              <form onSubmit={handleSubmit} data-readdy-form className="space-y-6">
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-[#0D1B2A] mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    className="w-full px-5 py-4 bg-[#F8FAFB] border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#00D9FF] focus:border-transparent"
                    placeholder="Your name"
                  />
                </div>

                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-[#0D1B2A] mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="contact-email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    className="w-full px-5 py-4 bg-[#F8FAFB] border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#00D9FF] focus:border-transparent"
                    placeholder="your.email@example.com"
                  />
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-[#0D1B2A] mb-2">
                    Subject
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                    required
                    className="w-full px-5 py-4 bg-[#F8FAFB] border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#00D9FF] focus:border-transparent"
                    placeholder="How can we help?"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-[#0D1B2A] mb-2">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-5 py-4 bg-[#F8FAFB] border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#00D9FF] focus:border-transparent resize-none"
                    placeholder="Tell us more about your inquiry..."
                  ></textarea>
                  <div className="text-right text-xs text-gray-500 mt-1">
                    {formData.message.length}/500 characters
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full py-4 bg-[#00D9FF] text-white font-semibold rounded-lg hover:bg-[#00C4E6] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>

                {submitStatus === 'success' && (
                  <div className="p-4 bg-green-50 border border-green-200 rounded-lg text-green-800 text-sm text-center">
                    Thank you for contacting us! We'll get back to you soon.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-800 text-sm text-center">
                    Something went wrong. Please try again or email us directly.
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
